module.exports = __webpack_public_path__ + "officialStatic/fonts/PingFangSCHeavy.0755e4d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/woff2/PingFangSCHeavy.woff2
// module id = CqU5
// module chunks = 0